<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">work</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Cuentas de Trabajo</h1>
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ listaCuentas.length }} cuentas
      </span>
    </div>
    <button type="button" (click)="openCreateDialog()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      Agregar cuenta
    </button>
  </div>
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ listaCuentas.length }} cuentas
  </span>

  <app-working-account-list [listaCuentas]="listaCuentas" (seleccion)="onSeleccion($event)" (reloadAccountList)="reloadAccount()" [seleccionable]="seleccionable" (actualizarCuenta)="openCreateDialog($event)"></app-working-account-list>
</div>
